export default "__VITE_ASSET__DZAHyITm__"